<script setup lang="ts">
const { items } = defineProps<{items: Array<{title: string; href: string, disabled: boolean }>}>()
</script>

<template>
  <v-breadcrumbs class="pl-0" :items="items">
    <template v-slot:divider>
      <v-icon icon="mdi-chevron-right"></v-icon>
    </template>
  </v-breadcrumbs>
</template>

